export const SCENARIOS = {
  UNLINK_TWO: 'unlink-two',
  PENDING_REVIEW: 'pending-review',
  REMOVE_INDIVIDUAL: 'remove-individual',
  UNLINKED: 'unlinked',
} as const;

export type Scenario = (typeof SCENARIOS)[keyof typeof SCENARIOS];
